import axios from "axios";
import apiService from "./apiService";

const baseUrl = process.env.REACT_APP_API_URL;

export default {
  /**
   *  Gets all templates
   * @param {string} endpoint
   */
  getTemplates: async (page, criteria = null) =>
    apiService.get(`templates?page=${page}`, criteria),

  getTemplate: async id => apiService.get("templates/".concat(id)),

  createTemplate: async data => {
    const templateName = data.get("templateName");
    return apiService.post(
      "templates",
      data,
      `Uploading template '${templateName}'.`,
      `Template '${templateName}' created.`
    );
  },

  updateTemplate: async (id, data) => {
    const templateName = data.get("templateName");
    return apiService.put(
      "templates/".concat(id),
      data,
      `Uploading template '${templateName}'.`,
      `Template '${templateName}' updated.`
    );
  },

  deleteTemplate: async id =>
    apiService.del("templates/".concat(id), "Template deleted")
};



// WEBPACK FOOTER //
// ./src/services/api/templateService.js